/**
 * Created by Vladislav on 19.02.2026.
 */

const ComicsAction = function (f) {
    const location = cleverapps.meta.getSelectedLocation();
    const needComics = location.isCompleted() && location.isLocationCompleted && !location.isLocationCompleted();
    if (needComics) {
        const comics = cleverapps.styles.comicses[`finishEpisode${location.getStage()}`] || cleverapps.styles.comicses.finishEpisode;
        if (comics) {
            cleverapps.focusManager.compound(f, [
                (f) => {
                    ComicsScene.showComics(f, comics);
                },
                (f) => {
                    cleverapps.meta.gotoMainLocation(f);
                }
            ]);
            return;
        }
    }

    f();
};